import Vue from 'vue'
import { Cell, CellGroup, Field, Button, Row, Col,Dialog } from 'vant';
Vue.use(Field).use(Cell).use(CellGroup).use(Button).use(Row).use(Col).use(Dialog);